import { useRouter, useSearchParams } from 'next/navigation';

export const usePaginationPageChange = () => {
	const router = useRouter();
	const searchParams = useSearchParams();

	const currentPage = searchParams?.get('current_page') ?? '1';

	const handlePageChange = (newPage: number) => {
		const newSearchParams = new URLSearchParams(searchParams.toString());
		newSearchParams.set('current_page', newPage.toString());
		router.replace(`?${newSearchParams.toString()}`, {
			scroll: true
		});
	};

	return {
		currentPage,
		handlePageChange
	};
};
